import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-main-menu',
  imports: [RouterModule, MatButtonModule],
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent implements OnInit, OnDestroy {
  public watchMarketplaceLink: string = '/market/advanced-search';
  private routerSubscription: Subscription = Subscription.EMPTY;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.updateMarketplaceLink());

    this.updateMarketplaceLink();
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  private updateMarketplaceLink(): void {
    const url = this.router.url;
  
    const isWatchDetail = /^\/watch\/\d+$/.test(url);
  
    if (url === '/market' || isWatchDetail) {
      this.watchMarketplaceLink = '/market/advanced-search';
    } else if (url === '/market/advanced-search') {
      this.watchMarketplaceLink = '/market';
    } else {
      this.watchMarketplaceLink = '/market/advanced-search';
    }
  }
  
}
